import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const languageMap = {
  english: 'en',
  french: 'fr',
  spanish: 'es',
  german: 'de',
  portuguese: 'pt',
  dutch: 'nl',
  norwegian: 'no',
  italian: 'it',
  japanese:'ja',
  romanian: "ro",
  turkish: "tr",
  polish: "pl",
  swedish: "sv",
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        Search: {
          Terms: "Terms",
          "Privacy Policy": "Privacy Policy",
          "Do Not Track": "Do Not Track",
          "For Advertisers": "For Advertisers",
          "About Us": "About Us",
          "Contact Us": "Contact Us",
          "Do Not Sell My Data": "Do Not Sell My Data",
          "Privacy and Terms are subject to change": "Privacy and Terms are subject to change",
          "Search with Bing": "Search with Bing",
          "Search with Google": "Search with Google",
          "Read More": "Read More",
          Ad: "Ad",
          "Web Results": "Web Results",
          "Sponsored Results for": "Sponsored Results for: ",
          "Related Searches": "Related Searches",
        },
        Content: {
          Terms: "Terms",
          "Privacy Policy": "Privacy Policy",
          "Do Not Track": "Do Not Track",
          "Do Not Sell My Data": "Do Not Sell My Data",
          "For Advertisers": "For Advertisers",
          "Privacy and Terms are subject to change": "Privacy and Terms are subject to change",
          "Read More": "Read More",
          "Read Less": "Read Less",
          "Next Page": "Next Page",
          "Previous Page": "Previous Page",
          and: "and",
          "Content created with Human Assistance": "Content created with Human Assistance",
          "Published On": "Published On:",
          "About Us": "About Us",
          "Contact Us": "Contact Us",
          "min read": "min read"
        },
        Home: {
          "Search the web": "Search the web",
          "Ads related to": "Ads related to: ",
        },
        Common: {
          "READ MORE": "READ MORE",
          "LEARN MORE ❯": "LEARN MORE ❯",
          "LEARN MORE": "LEARN MORE",
          "SEE IT": "SEE IT",
          "SEE IT ❯": "SEE IT ❯",
          Search: "Search",
          "Sitemap": "Sitemap",
        }
      }
    },
    de: {
      translation: {
        Search: {
          Terms: "Bedingungen",
          "Privacy Policy": "Datenschutzrichtlinie",
          "Do Not Track": "Nicht verfolgen",
          "For Advertisers": "Für Werbetreibende",
          "About Us": "Über uns",
          "Contact Us": "Kontaktieren Sie uns",
          "Do Not Sell My Data": "Verkaufen Sie meine Daten nicht",
          "Privacy and Terms are subject to change": "Datenschutz und Bedingungen können sich ändern",
          "Search with Bing": "Suche mit Bing",
          "Search with Google": "Suche mit Google",
          "Read More": "Mehr lesen",
          Ad: "Anzeige",
          "Web Results": "Web-Ergebnisse",
          "Sponsored Results for": "Gesponserte Ergebnisse für: ",
          "Related Searches": "Verwandte Suchanfragen",
        },
        Content: {
          Terms: "Bedingungen",
          "Privacy Policy": "Datenschutzrichtlinie",
          "Do Not Track": "Nicht verfolgen",
          "For Advertisers":"Für Werbetreibende",
          "Do Not Sell My Data": "Verkaufen Sie meine Daten nicht",
          "Privacy and Terms are subject to change": "Datenschutz und Bedingungen können sich ändern",
          "Read More": "Mehr lesen",
          "Read Less": "Weniger lesen",
          "Next Page": "Nächste Seite",
          "Previous Page": "Vorherige Seite",
          "About Us": "Über uns",
          "Contact Us": "Kontaktieren Sie uns",
          and: "und",
          "Content created with Human Assistance": "Mit menschlicher Unterstützung erstellte Inhalte",
          "Published On": "Veröffentlicht am:",
          "min read": "min Lesezeit"
        },
        Home: {
          "Search the web": "Durchsuche das Web",
          "Ads related to": "Anzeigen im Zusammenhang mit: ",
        },
        Common: {
          Search: "Suchen",
          "READ MORE": "MEHR LESEN",
          "LEARN MORE ❯": "ERFAHREN SIE MEHR ❯",
          "LEARN MORE": "ERFAHREN SIE MEHR",
          "SEE IT": "SEHEN SIE ES",
          "SEE IT ❯": "SEHEN SIE ES ❯",
          "Sitemap": "Sitemap",
        }
      }
    },
    es: {
      translation: {
        Search: {
          Terms: "Términos",
          "Privacy Policy": "Política de privacidad",
          "Do Not Track": "No rastrear",
          "For Advertisers": "Para los anunciantes",
          "About Us": "Sobre nosotros",
          "Contact Us": "Contáctenos",
          "Do Not Sell My Data": "No venda mis datos",
          "Privacy and Terms are subject to change": "La privacidad y los términos están sujetos a cambios",
          "Search with Bing": "Buscar con Bing",
          "Search with Google": "Buscar con Google",
          "Read More": "Leer más",
          Ad: "Anuncio",
          "Web Results": "Resultados web",
          "Sponsored Results for": "Resultados patrocinados para: ",
          "Related Searches": "Búsquedas Relacionadas",
        },
        Content: {
          Terms: "Términos",
          "Privacy Policy": "Política de privacidad",
          "Do Not Track": "No rastrear",
          "For Advertisers":"Para los anunciantes",
          "Do Not Sell My Data": "No venda mis datos",
          "Privacy and Terms are subject to change": "La privacidad y los términos están sujetos a cambios",
          "Read More": "Leer más",
          "Read Less": "Leer menos",
          "Content created with Human Assistance": "Contenido creado con Asistencia Humana",
          "Published On": "Publicado el:",
          "Next Page": "Siguiente página",
          "Previous Page": "Pagina anterior",
          "About Us": "Sobre nosotros",
          "Contact Us": "Contáctenos",
          and: "y",
          "min read": "min de lectura",
        },
        Home: {
          "Search the web": "Busca en la web",
          "Ads related to": "Anuncios relacionados con: ",
        },
        Common: {
          "READ MORE": "LEER MÁS",
          "LEARN MORE ❯": "APRENDE MÁS ❯",
          "LEARN MORE": "APRENDE MÁS",
          "SEE IT": "MÍRALO",
          "SEE IT ❯": "MÍRALO ❯",
          Search: "Buscar",
          "Sitemap": "Sitemap",
        }
      }
    },
    fr: {
      translation: {
        Search: {
          Terms: "Termes",
          "Privacy Policy": "politique de confidentialité",
          "Do Not Track": "Ne pas suivre",
          "For Advertisers": "Pour les annonceurs",
          "About Us": "À propos de nous",
          "Contact Us": "Contactez-nous",
          "Do Not Sell My Data": "Ne vendez pas mes données",
          "Privacy and Terms are subject to change": "La confidentialité et les termes sont susceptibles de changer",
          "Search with Bing": "Rechercher avec Bing",
          "Search with Google": "Rechercher avec Google",
          "Read More": "En savoir plus",
          Ad: "Annonce",
          "Web Results": "Résultats Web",
          "Sponsored Results for": "Résultats sponsorisés pour: ",
          "Related Searches": "Recherches Associées",
        },
        Content: {
          Terms: "Termes",
          "Privacy Policy": "politique de confidentialité",
          "Do Not Track": "Ne pas suivre",
          "For Advertisers":"Pour les annonceurs",
          "Do Not Sell My Data": "Ne vendez pas mes données",
          "Privacy and Terms are subject to change": "La confidentialité et les termes sont susceptibles de changer",
          "Read More": "En savoir plus",
          "Read Less": "En savoir moins",
          "Next Page": "Page suivante",
          "Previous Page": "Page précédente",
          and: "et",
          "About Us": "À propos de nous",
          "Contact Us": "Contactez-nous",
          "min read": "min de lecture",
          "Content created with AI assistance": "Contenu créé avec l'aide de l'IA",
          "Content created with Human Assistance": "Contenu créé avec Human Assistance",
          "Published On": "Publié le:",
        },
        Home: {
          "Search the web": "Rechercher sur le Web",
          "Ads related to": "Annonces liées à: ",
        },
        Common: {
          Search: "Recherche",
          "READ MORE": "EN SAVOIR PLUS",
          "LEARN MORE ❯": "APPRENDRE ENCORE PLUS ❯",
          "LEARN MORE": "APPRENDRE ENCORE PLUS",
          "SEE IT": "VOIR",
          "SEE IT ❯": "VOIR ❯",
          "Sitemap": "Sitemap",
        }
      }
    },
    pt: {
      translation: {
        Search: {
          Terms: "Termos",
          "Privacy Policy": "Política de Privacidade",
          "Do Not Track": "Não rastreie",
          "For Advertisers": "Para anunciantes",
          "About Us": "Sobre nós",
          "Contact Us": "Contate-nos",
          "Do Not Sell My Data": "Não venda meus dados",
          "Privacy and Terms are subject to change": "Privacidade e termos estão sujeitos a alterações",
          "Search with Bing": "Pesquise com o Bing",
          "Search with Google": "Pesquise com o Google",
          "Read More": "consulte Mais informação",
          Ad: "De Anúncios",
          "Web Results": "Resultados da Web",
          "Sponsored Results for": "Resultados patrocinados para: ",
          "Related Searches": "Pesquisas Relacionadas"
        },
        Content: {
          Terms: "Termos",
          "Privacy Policy": "Política de Privacidade",
          "Do Not Track": "Não rastreie",
          "For Advertisers":"Para anunciantes",
          "Do Not Sell My Data": "Não venda meus dados",
          "Privacy and Terms are subject to change": "Privacidade e termos estão sujeitos a alterações",
          "Read More": "consulte Mais informação",
          "Read Less": "consulte Menos Informação",
          "Next Page": "Próxima página",
          "Previous Page": "Página anterior",
          and: "e",
          "Content created with Human Assistance": "Conteúdo criado com Assistência Humana",
          "Published On": "Publicado em:",
          "About Us": "Sobre nós",
          "Contact Us": "Contate-nos",
          "min read": "min de leitura",
        },
        Home: {
          "Search the web": "Pesquise na internet",
          "Ads related to": "Anúncios relacionados a: ",
        },
        Common: {
          Search: "Procurar",
          "READ MORE": "CONSULTE MAIS INFORMAÇÃO",
          "LEARN MORE ❯": "SABER MAIS ❯",
          "LEARN MORE": "SABER MAIS",
          "SEE IT": "VEJA",
          "SEE IT ❯": "VEJA ❯",
          "Sitemap": "Sitemap",
        }
      }
    },
    nl: {
      translation: {
        Search: {
          Terms: "Voorwaarden",
          "Privacy Policy": "Privébeleid",
          "Do Not Track": "Niet traceren",
          "For Advertisers": "Voor adverteerders",
          "About Us": "Over ons",
          "Contact Us": "Neem contact met ons op",
          "Do Not Sell My Data": "Verkoop mijn gegevens niet",
          "Privacy and Terms are subject to change": "Privacy en termen zijn onderhevig aan verandering",
          "Search with Bing": "Zoek met Bing",
          "Search with Google": "Zoek met Google",
          "Read More": "Lees verder",
          Ad: "Advertentie",
          "Web Results": "Webresultaten",
          "Sponsored Results for": "Gesponsorde resultaten voor: ",
          "Related Searches": "Verwante Zoekopdrachten",
        },
        Content: {
          Terms: "Voorwaarden",
          "Privacy Policy": "Privébeleid",
          "Do Not Track": "Niet traceren",
          "For Advertisers":"Voor adverteerders",
          "Do Not Sell My Data": "Verkoop mijn gegevens niet",
          "Privacy and Terms are subject to change": "Privacy en termen zijn onderhevig aan verandering",
          "Read More": "Lees verder",
          "Read Less": "Minder weergeven",
          "Next Page": "Volgende bladzijde",
          "Previous Page": "Vorige bladzijde",
          and: "en",
          "Content created with Human Assistance": "Inhoud gemaakt met menselijke hulp",
          "Published On": "Gepubliceerd Op:",
          "About Us": "Over ons",
          "Contact Us": "Neem contact met ons op",
          "min read": "min lezen",
        },
        Home: {
          "Search the web": "Zoeken op het internet",
          "Ads related to": "Advertenties gerelateerd aan: ",
        },
        Common: {
          Search: "Zoekopdracht",
          "READ MORE": "LEES VERDER",
          "LEARN MORE ❯": "KOM MEER TE WETEN ❯",
          "LEARN MORE": "KOM MEER TE WETEN",
          "SEE IT": "HET ZIEN",
          "SEE IT ❯": "HET ZIEN ❯",
          "Sitemap": "Sitemap",
        }
      }
    },
    no: {
      translation: {
        Search: {
          Terms: "Vilkår",
          "Privacy Policy": "Privacybeleid",
          "Do Not Track": "Ikke spor",
          "For Advertisers": "For annonsører",
          "About Us": "Om oss",
          "Contact Us": "Kontakt oss",
          "Do Not Sell My Data": "Ikke selg dataene mine",
          "Privacy and Terms are subject to change": "Personvern og vilkår kan endres",
          "Search with Bing": "Søk med Bing",
          "Search with Google": "Søk med Google",
          Ad: "Annonse",
          "Web Results": "Nettresultater",
          "Sponsored Results for": "Sponsede resultater for: ",
          "Related Searches": "Relaterte søk",
        },
        Content: {
          Terms: "Vilkår",
          "Privacy Policy": "Privacybeleid",
          "Do Not Track": "Ikke spor",
          "For Advertisers":"For annonsører",
          "Do Not Sell My Data": "Ikke selg dataene mine",
          "Privacy and Terms are subject to change": "Personvern og vilkår kan endres",
          "Read More": "Les mer",
          "Read Less": "Les mindre",
          "Next Page": "Neste side",
          "Previous Page": "Forrige side",
          and: "og",
          "Content created with Human Assistance": "Innhold laget med Human Assistance",
          "Published On": "Publisert på:",
          "About Us": "Om oss",
          "Contact Us": "Kontakt oss",
          "min read": "min lesing",
        },
        Home: {
          "Search the web": "Søke på nettet",
          "Ads related to": "Annonser relatert til: ",
        },
        Common: {
          Search: "Søk",
          "READ MORE": "LES MER",
          "LEARN MORE ❯": "LÆRE MER ❯",
          "LEARN MORE": "LÆRE MER",
          "SEE IT": "SE DET",
          "SEE IT ❯": "SE DET ❯",
          "Sitemap": "Sitemap",
        }
      }
    },
    it: {
      translation: {
        Search: {
          Terms: "Termini",
          "Privacy Policy": "Politica sulla privacy",
          "Do Not Track": "Non tracciare",
          "For Advertisers":"Per gli inserzionisti",
          "Do Not Sell My Data": "Non vendete i miei dati",
          "Privacy and Terms are subject to change": "La privacy e i termini sono soggetti a modifiche",
          "Search with Bing": "Ricerca con Bing",
          "Search with Google": "Ricerca con Google",
          "Read More": "Leggi tutto",
          Ad: "Annuncio",
          "Web Results": "Risultati web",
          "Sponsored Results for": "Risultati sponsorizzati per: ",
          "Related Searches": "Ricerche correlate",
          "Contact Us": 'Contattaci',
          "About Us": "Chi siamo",
        },
        Content: {
          Terms: "Termini",
          "Privacy Policy": "Politica sulla privacy",
          "Do Not Track": "Non tracciare",
          "For Advertisers":"Per gli inserzionisti",
          "Do Not Sell My Data": "Non vendete i miei dati",
          "Privacy and Terms are subject to change": "La privacy e i termini sono soggetti a modifiche",
          "Read More": "Per saperne di più",
          "Read Less": "Leggi meno",
          "Next Page": "Pagina successiva",
          "Previous Page": "Pagina precedente",
          and: "e",
          "Contact Us": 'Contattaci',
          "About Us": "Chi siamo",
          "min read": "min di lettura",
          "Content created with Human Assistance": "Contenuti creati con l'assistenza umana",
          "Published On": "Pubblicato il:",
        },
        Home: {
          "Search the web": "Ricerca sul web",
          "Ads related to": "Annunci correlati a: ",
        },
        Common: {
          "READ MORE": "LEGGI TUTTO",
          "LEARN MORE ❯": "PER SAPERNE DI PIÚ ❯",
          "LEARN MORE": "PER SAPERNE DI PIÚ",
          "SEE IT": "GUARDALO",
          "SEE IT ❯": "GUARDALO ❯",
          Search: "Ricerca",
          "Sitemap": "Sitemap",
        }
      }
    },
    ja: {
      translation: {
        Search: {
          Terms: "利用規約",
          "Privacy Policy": "プライバシーポリシー",
          "Do Not Track": "追跡拒否",
          "For Advertisers": "広告主向け",
          "About Us": "私たちについて",
          "Contact Us": "お問い合わせ",
          "Do Not Sell My Data": "私のデータを販売しないでください",
          "Privacy and Terms are subject to change": "プライバシーと利用規約は変更される場合があります",
          "Search with Bing": "Bingで検索",
          "Search with Google": "Googleで検索",
          "Read More": "続きを読む",
          Ad: "広告",
          "Web Results": "ウェブ結果",
          "Sponsored Results for": "のスポンサー付き結果：",
          "Related Searches": "関連検索",
        },
        Content: {
          Terms: "利用規約",
          "Privacy Policy": "プライバシーポリシー",
          "Do Not Track": "追跡拒否",
          "Do Not Sell My Data": "私のデータを販売しないでください",
          "For Advertisers": "広告主向け",
          "Privacy and Terms are subject to change": "プライバシーと利用規約は変更される場合があります",
          "Read More": "続きを読む",
          "Read Less": "閉じる",
          "Next Page": "次のページ",
          "Previous Page": "前のページ",
          and: "および",
          "About Us": "私たちについて",
          "Contact Us": "お問い合わせ",
          "min read": "分で読む",
          "Content created with Human Assistance": "人間の支援を受けて作成されたコンテンツ",
          "Published On": "発行日"
        },
        Home: {
          "Search the web": "ウェブを検索",
          "Ads related to": "関連広告：",
        },
        Common: {
          "READ MORE": "続きを読む",
          "LEARN MORE ❯": "詳細を見る ❯",
          "LEARN MORE": "詳細を見る",
          "SEE IT": "見る",
          "SEE IT ❯": "見る ❯",
          Search: "検索",
          "Sitemap": "サイトマップ",
        }
      }
    },
    ro: {
      translation: {
        Search: {
          Terms: "Termeni",
          "Privacy Policy": "Politica de Confidențialitate",
          "Do Not Track": "Nu Urmări",
          "For Advertisers": "Pentru Advertiseri",
          "About Us": "Despre noi",
          "Contact Us": "Contactați-ne",
          "Do Not Sell My Data": "Nu Vinde Datele Mele",
          "Privacy and Terms are subject to change": "Confidențialitatea și Termenii pot fi schimbați",
          "Search with Bing": "Căutați cu Bing",
          "Search with Google": "Căutați cu Google",
          "Read More": "Citește Mai Mult",
          Ad: "Reclama",
          "Web Results": "Rezultate Web",
          "Sponsored Results for": "Rezultate sponsorizate pentru:",
          "Related Searches": "Căutări Asemănătoare",
        },
        Content: {
          Terms: "Termeni",
          "Privacy Policy": "Politica de Confidențialitate",
          "Do Not Track": "Nu Urmări",
          "Do Not Sell My Data": "Nu Vinde Datele Mele",
          "For Advertisers": "Pentru Advertiseri",
          "Privacy and Terms are subject to change": "Confidențialitatea și Termenii pot fi schimbați",
          "Read More": "Citește Mai Mult",
          "Read Less": "Citește Mai Puțin",
          "Next Page": "Pagina următoare",
          "Previous Page": "Pagina anterioară",
          and: "și",
          "Content created with Human Assistance": "Conținut Creat cu Asistență Umană",
          "Published On": "Publicat Pe:",
          "About Us": "Despre noi",
          "Contact Us": "Contactați-ne",
          "min read": "Min Citește"
        },
        Home: {
          "Search the web": "Caută pe web",
          "Ads related to": "Anunțuri legate de",
        },
        Common: {
          "READ MORE": "CITEȘTE MAI MULT",
          "LEARN MORE ❯": "AFLĂ MAI MULTE ❯",
          "LEARN MORE": "AFLĂ MAI MULTE",
          "SEE IT": "VEZI",
          "SEE IT ❯": "VEZI ❯",
          Search: "Caută",
          "Sitemap": "Harta site-ului",
        }
      }
    },
    tr: {
      translation: {
        Search: {
          Terms: "Şartlar",
          "Privacy Policy": "Gizlilik Politikası",
          "Do Not Track": "Takip Etme",
          "For Advertisers": "Reklamverenler için",
          "About Us": "Hakkımızda",
          "Contact Us": "Bize Ulaşın",
          "Do Not Sell My Data": "Verilerimi Satma",
          "Privacy and Terms are subject to change": "Gizlilik ve Şartlar değişebilir",
          "Search with Bing": "Bing ile Arama Yapın",
          "Search with Google": "Google ile arama yapın",
          "Read More": "Daha Fazla Oku",
          Ad: "Reklam",
          "Web Results": "Web Sonuçları",
          "Sponsored Results for": "İçin Sponsorlu Sonuçlar",
          "Related Searches": "İlgili Aramalar",
        },
        Content: {
          Terms: "Şartlar",
          "Privacy Policy": "Gizlilik Politikası",
          "Do Not Track": "Takip Etme",
          "Do Not Sell My Data": "Verilerimi Satma",
          "For Advertisers": "Reklamverenler için",
          "Privacy and Terms are subject to change": "Gizlilik ve Şartlar değişebilir",
          "Read More": "Daha Fazla Oku",
          "Read Less": "Daha Az Oku",
          "Next Page": "Sonraki Sayfa",
          "Previous Page": "Önceki Sayfa",
          and: "ve",
          "Content created with Human Assistance": "nsan Yardımıyla Oluşturulan İçerik",
          "Published On": "Yayınlanma Tarihi:",
          "About Us": "Hakkımızda",
          "Contact Us": "Bize Ulaşın",
          "min read": "Min Okuyun"
        },
        Home: {
          "Search the web": "Web'de Ara",
          "Ads related to": "İlgili Reklamlar",
        },
        Common: {
          "READ MORE": "DAHA FAZLA OKU",
          "LEARN MORE ❯": "DAHA FAZLA BILGI ❯",
          "LEARN MORE": "DAHA FAZLA BILGI",
          "SEE IT": "GÖR",
          "SEE IT ❯": "GÖR ❯",
          Search: "Ara",
          "Sitemap": "Site Haritası",
        }
      }
    },
    pl: {
      translation: {
        Search: {
          Terms: "Warunki",
          "Privacy Policy": "Polityka Prywatności",
          "Do Not Track": "Nie Śledź",
          "For Advertisers": "Dla Reklamodawców",
          "About Us": "O nas",
          "Contact Us": "Kontakt",
          "Do Not Sell My Data": "Nie Sprzedawaj Moich Danych",
          "Privacy and Terms are subject to change": "Polityka prywatności i Warunki mogą się zmienić",
          "Search with Bing": "Wyszukiwanie za pomocą Bing",
          "Search with Google": "Wyszukiwanie w Google",
          "Read More": "Czytaj Więcej",
          Ad: "Reklama",
          "Web Results": "Wyniki w sieci",
          "Sponsored Results for": "Sponsorowane Wyniki dla:",
          "Related Searches": "Podobne Wyszukiwania",
        },
        Content: {
          Terms: "Warunki",
          "Privacy Policy": "Polityka Prywatności",
          "Do Not Track": "Nie Śledź",
          "Do Not Sell My Data": "Nie Sprzedawaj Moich Danych",
          "For Advertisers": "Dla Reklamodawców",
          "Privacy and Terms are subject to change": "Polityka prywatności i Warunki mogą się zmienić",
          "Read More": "Czytaj Więcej",
          "Read Less": "Czytaj Mniej",
          "Next Page": "Następna strona",
          "Previous Page": "Poprzednia strona",
          and: "i",
          "Content created with Human Assistance": "Treść Stworzona z Pomocą Człowieka",
          "Published On": "Opublikowano Dnia:",
          "About Us": "O nas",
          "Contact Us": "Kontakt",
          "min read": "Min Czytaj"
        },
        Home: {
          "Search the web": "Przeszukaj sieć",
          "Ads related to": "Reklamy powiązane z",
        },
        Common: {
          "READ MORE": "CZYTAJ WIĘCEJ",
          "LEARN MORE ❯": "DOWIEDZ SIĘ WIĘCEJ ❯",
          "LEARN MORE": "DOWIEDZ SIĘ WIĘCEJ",
          "SEE IT": "ZOBA CZ",
          "SEE IT ❯": "ZOBA CZ ❯",
          Search: "Szukaj",
          "Sitemap": "Mapa witryny",
        }
      }
    },
    sv: {
      translation: {
        Search: {
          Terms: "Villkor",
          "Privacy Policy": "Integritetspolicy",
          "Do Not Track": "Spåra inte",
          "For Advertisers": "För annonsörer",
          "About Us": "Om oss",
          "Contact Us": "Kontakta oss",
          "Do Not Sell My Data": "Sälj inte mina uppgifter",
          "Privacy and Terms are subject to change": "Integritetspolicy och Villkor kan komma att ändras",
          "Search with Bing": "Sök med Bing",
          "Search with Google": "Sök med Google",
          "Read More": "Läs mer",
          Ad: "Annons",
          "Web Results": "Sökresultat",
          "Sponsored Results for": "Sponsrade resultat för:",
          "Related Searches": "Relaterade sökningar",
        },
        Content: {
          Terms: "Villkor",
          "Privacy Policy": "Integritetspolicy",
          "Do Not Track": "Spåra inte",
          "Do Not Sell My Data": "Sälj inte mina uppgifter",
          "For Advertisers": "För annonsörer",
          "Privacy and Terms are subject to change": "Integritetspolicy och Villkor kan komma att ändras",
          "Read More": "Läs mer",
          "Read Less": "Läs mindre",
          "Next Page": "Nästa sida",
          "Previous Page": "Föregående sida",
          and: "och",
          "Content created with Human Assistance": "Innehåll skapat med mänsklig hjälp",
          "Published On": "Publicerad:",
          "About Us": "Om oss",
          "Contact Us": "Kontakta oss",
          "min read": "min läsning"
        },
        Home: {
          "Search the web": "Sök på webben",
          "Ads related to": "Annonser relaterade till",
        },
        Common: {
          "READ MORE": "LÄS MER",
          "LEARN MORE ❯": "LÄR DIG MER ❯",
          "LEARN MORE": "LÄR DIG MER",
          "SEE IT": "SE DET",
          "SEE IT ❯": "SE DET ❯",
          Search: "Sök",
          "Sitemap": "Sidkarta",
        }
      }
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

